module.exports = __webpack_public_path__ + "static/media/congratulate_map_important.fe0f81d9.svg";